import { Link } from '../../../../components/Link'
import { FieldWithLabel } from 'components/FieldWithLabel/FieldWithLabel'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { routes } from 'router'

const AdditionalInfoPreview = () => {
  const contractDetailsContext = useContractDetailsContext()

  const { details } = contractDetailsContext.state

  return (
    <>
      {details?.rfp_name && (
        <FieldWithLabel title="Initial RFP">
          <Link to={`${routes.bidding}${routes.rfp}/${details.rfp}`}>
            {details.rfp_name}
          </Link>
        </FieldWithLabel>
      )}
      {details?.prs_name && (
        <FieldWithLabel title="Initial PRS">
          <Link to={`${routes.productRequests}/${details.prs}`}>
            {details.prs_name}
          </Link>
        </FieldWithLabel>
      )}
    </>
  )
}

export default AdditionalInfoPreview
